import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import { options } from "../pages/dashboard";
import Br from "./Br";
import { Select, Button, FormLayout, TextStyle } from "@shopify/polaris";

// Load the WhatApp number and Language update form
const WhatsAppNumberForm = ({
  phoneNumberError,
  whatsAppNumber,
  change,
  selectChange,
  languageCode,
  saving,
  isHomePage,
}) => {
  const [homePage, setHomePage] = useState(isHomePage);
  return (
    <FormLayout>
      <div>
        <TextStyle variation="subdued">Your WhatsApp Number</TextStyle>
        <span className="important">*</span>
        {phoneNumberError ? (
          <span style={{ marginLeft: "20px", color: "red" }}>
            Please enter the valid whatsapp number
          </span>
        ) : (
          ""
        )}
      </div>
      <div style={{ marginTop: "-12px" }}>
        <PhoneInput
          autoFormat={false}
          countryCodeEditable={false}
          enableSearch={true}
          containerStyle={{ zIndex: "999" }}
          inputProps={{
            required: true,
          }}
          inputStyle={{
            width: "100%",
            borderColor: "#c4cdd5",
          }}
          country={"us"}
          value={whatsAppNumber}
          onChange={change}
        />
      </div>
      <Select
        label={<TextStyle variation="subdued">Language</TextStyle>}
        options={options}
        onChange={(value) => selectChange(value)}
        value={languageCode}
      />

      {homePage ? (
        <div style={{ textAlign: "center" }}>
          <Br height={10} />
          <Button size="large" primary submit loading={saving}>
            Submit
          </Button>
          <Br height={15} />
        </div>
      ) : (
        ""
      )}
    </FormLayout>
  );
};
export default WhatsAppNumberForm;
